<template>
  <div>
    <payment-modal ref="paymentModal" :competition="competition" v-on:update="onUpdatePayment"></payment-modal>
    <registration-modal ref="registrationModal" :competition="competition" v-on:update="onUpdateRegistration"></registration-modal>
    <delete-modal ref="deleteModal" v-on:confirmed="removeRow"></delete-modal>

    <b-row class="mb-5">
      <b-col lg=6 class="d-none d-lg-block d-xl-block">
        <b-button size="sm" v-on:click="exportRegistrations">Anmeldungen Exportieren</b-button>
        <b-button size="sm" v-on:click="exportBilling" :disabled="!competition.prices">Abrechnung Exportieren</b-button>
      </b-col>

      <b-col cols=12 lg=6 class="text-left text-lg-right text-xl-right">
        <b-button variant="primary" size="sm" v-on:click=$refs.registrationModal.add()>Anmeldung hinzufügen</b-button>
      </b-col>
    </b-row>

    <b-row class="mb-2">
      <b-col cols="8"><b-input type="search" v-model="query.q" placeholder="Suchen..." @keyup="queryKeyUp"></b-input></b-col>
      <b-col cols="3">
        <b-form-select label="Status" v-model="query.deleted" v-on:change="search" :options="[
            {value: false, text: 'aktuell'},
            {value: true, text: 'gelöscht'},
            {value: null, text: 'alle'}
          ]"></b-form-select>
      </b-col>
      <b-col cols="1"><b-btn variant="primary" @click="search">Suchen</b-btn></b-col>
    </b-row>

    <registrations-table :rows="registrations" :price="competition.costs.price"
      v-on:edit="onEdit"
      v-on:delete="onDelete"
      v-on:payment="onPayment">
    </registrations-table>

    <b-row v-if="query.more" class="mb-5">
      <b-col class="text-sm-center clickable"><span @click="exec">mehr</span></b-col>
    </b-row>

  </div>
</template>

<script>
import RegistrationsTable from './registration/RegistrationsTable'
import RegistrationModal from './registration/RegistrationModal'
import PaymentModal from './registration/PaymentModal'
import DeleteModal from './registration/DeleteModal'
import {School, InvoiceAddress} from '@/models'

export default {
  name: 'Registrations',
  props: ['competition'],

  components: {
    RegistrationsTable,
    RegistrationModal,
    PaymentModal,
    DeleteModal
  },

  data: function () {
    return {
      query: {
        more: false,
        limit: 0,
        offset: 0,
        deleted: false,
        q: ''
      },
      registrations: []
    }
  },

  watch: {
    competition: (competition) => {
      if (competition) {
        this.search()
      }
    }
  },

  mounted: function () {
    this.routeToQuery()

    if (this.competition) {
      this.search()
    }
  },

  methods: {
    focusSearch () {
      // const isCtrlKey = navigator.platform.indexOf('Mac') > -1 ? event.metaKey : event.ctrlKey
      if (!(event.ctrlKey && event.keyCode === 70)) {
        return
      }

      event.preventDefault()
      document.getElementById('search').scrollIntoView({behavior: 'smooth'})
    },

    showDetails: (item) => {
      this.table.items.forEach((row) => {
        if (row.id !== item.id) {
          row._showDetails = false
        }
      })

      item._showDetails = !item._showDetails
    },

    onEdit (id) {
      const index = this.registrations.findIndex(e => e.id === id)
      this.$refs.registrationModal.edit(id, this.registrations[index].school)
    },

    onPayment (id) {
      this.$refs.paymentModal.edit(id)
    },

    onDelete (id) {
      const index = this.registrations.findIndex(e => e.id === id)
      const row = this.registrations[index]

      this.$eventHub.$emit(
        'confirm',
        'ACHTUNG! Hiermit wird die Anmeldungs für <strong>' + row.school.name + '</strong> unwideruflich gelöscht!',
        'Anmeldung löschen',
        () => {
          this.axios.delete('/registrations/' + id)
            .then(() => this.removeRow(index))
        }
      )
    },

    onUpdateRegistration (rsp) {
      if (!rsp.registration) {
        return
      }

      const { registration } = rsp.registration
      const idx = this.registrations.findIndex(elem => elem.id === registration.id)
      if (idx > -1) {
        this.$set(this.registrations[idx], 'registration', registration)
        return
      }

      this.registrations.push({
        id: registration.id,
        school: rsp.school,
        coordinator: rsp.coordinator,
        registrations: {
          count: registration.registrationCount,
          groups: registration.payload.registeredClasses
        },
        payment: registration.payment,
        deletedAt: registration.deletedAt,
        _showDetails: false
      })

      this.$eventHub.$emit('alertInfo', 'Anmeldung erfolgreich gespeichert')
    },

    onUpdatePayment (id, payment) {
      const index = this.registrations.findIndex(e => e.id === id)
      this.registrations[index].payment = payment
    },

    removeRow: function (index) {
      this.registrations.splice(index, 1)
    },

    queryKeyUp: function (event) {
      if (event.key === 'Enter') {
        this.search()
      }
    },

    search: function () {
      this.queryToRoute()

      this.registrations = []
      this.query.offset = 0
      this.exec()
    },

    routeToQuery: function () {
      const query = this.$route.query
      if (query.hasOwnProperty('deleted')) {
        this.query.deleted = query.deleted === 'true'
      } else {
        this.query.deleted = null
      }

      if (query.hasOwnProperty('q')) {
        this.query.q = query.q
      }
    },

    queryToRoute: function () {
      const query = {}
      if (this.query.deleted !== null) {
        query.deleted = this.query.deleted ? 'true' : 'false'
      }

      if (this.query.q !== '') {
        query.q = this.query.q
      }

      if (this.$route.query.deleted !== query.deleted || this.$route.query.q !== query.q) {
        this.$router.replace({path: this.$route.path, params: this.$route.params, query})
      }
    },

    exec: function () {
      const config = {params: {
        q: this.query.q.trim() && this.query.q.trim(),
        deleted: this.query.deleted,
        limit: this.query.limit && this.query.limit,
        offset: this.registrations.length
      }}

      if (this.$route.query.q !== config.params.q || parseInt(this.$route.query.offset || '') !== config.params.offset) {
        // this.$router.replace({name: this.$route.name, query: config.params})
      }

      this.axios.get('/competitions/' + this.competition.id + '/registrations', config)
        .then(rsp => {
          if (!rsp || !rsp.data || !rsp.data.registrations) {
            this.$eventHub.$emit('error', 'Fehler beim Laden der Registrierungen')
            return
          }

          this.query.more = rsp.data.more

          rsp.data.registrations.forEach(row => {
            const registration = row.registration

            this.registrations.push({
              id: registration.id,
              school: new School(row.school),
              invoiceAddress: new InvoiceAddress(row.invoiceAddress),
              coordinator: row.coordinator,
              registrations: {
                count: registration.registrationCount,
                groups: registration.payload.registeredClasses
              },
              payment: registration.payment,
              deletedAt: registration.deletedAt,
              _showDetails: false
            })
          })
        })
    },

    exportRegistrations: function () {
      this.$eventHub.$emit('download', '/competitions/' + this.competition.id + '/export/registrations')
    },

    exportBilling: function () {
      this.$eventHub.$emit('download', '/competitions/' + this.competition.id + '/export/billing')
    }
  },

  filters: {
    nl2br: function (value) {
      if (!value) return ''
      value = value.toString()
      return value.split('\n').join('<br/>')
    }
  }
}
</script>

<style scoped>
table#registrations ul {
  list-style-type: none;
}
</style>



// WEBPACK FOOTER //
// src/components/competitions/admin/Registrations.vue